function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgModalCloseButton = function SvgModalCloseButton(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    focusable: "false",
    height: 20,
    width: 20,
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M10.872,10.004 C11.321,9.864 11.747,9.631 12.102,9.275 L17.704,3.674 L16.29,2.26 L10.688,7.861 C10.298,8.252 9.665,8.252 9.274,7.861 L3.704,2.291 L2.29,3.705 L7.86,9.275 C8.224,9.639 8.66,9.875 9.121,10.013 C8.665,10.148 8.237,10.375 7.892,10.721 L2.29,16.322 L3.704,17.736 L9.307,12.135 C9.684,11.757 10.34,11.757 10.72,12.135 L16.29,17.705 L17.704,16.291 L12.134,10.721 C11.779,10.366 11.34,10.137 10.872,10.004",
    fill: "rgba(53, 52, 52, 1)",
    style: {
      transition: "fill 0.2s ease 0s"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgModalCloseButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modal-close-button.ddd86452.svg";
export { ForwardRef as ReactComponent };